/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsPublicWebClientConfigOptionsLogos interface.
 */
export function instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLogos(value) {
    if (!('CompanyLogo' in value) || value['CompanyLogo'] === undefined)
        return false;
    if (!('BrandLogo' in value) || value['BrandLogo'] === undefined)
        return false;
    if (!('WebPlayerLogo' in value) || value['WebPlayerLogo'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLogosFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLogosFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLogosFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'CompanyLogo': json['CompanyLogo'],
        'BrandLogo': json['BrandLogo'],
        'WebPlayerLogo': json['WebPlayerLogo'],
    };
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLogosToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLogosToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLogosToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'CompanyLogo': value['CompanyLogo'],
        'BrandLogo': value['BrandLogo'],
        'WebPlayerLogo': value['WebPlayerLogo'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsLogos.js.map